import { StaticImage } from "gatsby-plugin-image";
import across33 from "images/logos/33-across.png";
import apartmentTherapy from "images/logos/apartment-therapy.png";
import bauerMedia from "images/logos/bauer-media.png";
import britannica from "images/logos/britannica.png";
import connatix from "images/logos/connatix.png";
import gradient from "images/logos/gradient.svg";
import gumgum from "images/logos/gumgum.png";
import hearstAutos from "images/logos/hearst-autos.png";
import investingChannel from "images/logos/investing-channel.png";
import mobilefuse from "images/logos/mobilefuse.png";
import nativo from "images/logos/nativo.png";
import nexxen from "images/logos/nexxen.png";
import quizlet from "images/logos/quizlet.png";
import reverso from "images/logos/reverso.png";
import stepNetwork from "images/logos/step-network.png";
import system1 from "images/logos/system1.png";
import theDailyBeast from "images/logos/the-daily-beast.png";
import theWeatherCompany from "images/logos/the-weather-company.png";
import trustedMediaBrands from "images/logos/trusted-media-brands.png";
import type { FC } from "react";
import "./clients.scss";

const logos = [
    { src: apartmentTherapy, alt: "Apartment Therapy" },
    { src: bauerMedia, alt: "Bauer Media" },
    { src: britannica, alt: "Britannica" },
    { src: hearstAutos, alt: "Hearst Autos" },
    { src: investingChannel, alt: "Investing Channel" },
    { src: quizlet, alt: "Quizlet" },
    { src: reverso, alt: "Reverso" },
    { src: stepNetwork, alt: "Step Network" },
    { src: system1, alt: "System1" },
    { src: theDailyBeast, alt: "The Daily Beast" },
    { src: theWeatherCompany, alt: "The Weather Company" },
    { src: trustedMediaBrands, alt: "Trusted Media Brands" },
    { src: across33, alt: "33 Across" },
    { src: connatix, alt: "Connatix" },
    { src: gumgum, alt: "GumGum" },
    { src: mobilefuse, alt: "MobileFuse" },
    { src: nativo, alt: "Nativo" },
    { src: nexxen, alt: "Nexxen" },
];

const Clients: FC<{
    title?: string;
    topmargin?: boolean;
    bg?: string;
    showLink?: boolean;
    linkText?: string;
    linkTo?: string;
    linkColor?: string;
}> = ({ title, topmargin, bg, showLink, linkText, linkTo, linkColor }) => {
    return (
        //top margin for new and old game for yield manager page
        <div className={`component-wrapper ${topmargin ? "mt-180" : ""} change-margin-to-padding ${bg} pt-5`}>
            <img src={gradient} className={`gradient right`} style={{ top: "-250px" }} alt="gradient" />
            <div className="clients">
                <section className="enable-animation marquee-clients">
                    {title ? <h2 className="text-center mb-5">{title}</h2> : ""}
                    <div className="marquee ">
                        <ul className="marquee__group">
                            {logos.map(({ src, alt }) => (
                                <li key={alt}>
                                    <img src={src} alt={alt} loading="lazy" />
                                </li>
                            ))}
                        </ul>
                        <ul className="marquee__group aria_hidden" aria-hidden="true">
                            {logos.map(({ src, alt }) => (
                                <li key={alt}>
                                    <img src={src} alt="" loading="lazy" />
                                </li>
                            ))}
                        </ul>
                    </div>
                </section>
                {showLink && linkColor === "green" && (
                    <a href={linkTo} className="link-wrapper">
                        <span className="link-text">{linkText}</span>
                        <StaticImage src="images/logos/arrow.svg" alt="arrow" />
                    </a>
                )}
                {showLink && linkColor === "yellow" && (
                    <a href={linkTo} className="link-wrapper">
                        <span className="link-text-yellow">{linkText}</span>
                        <StaticImage src="images/logos/yellow-arrow.svg" alt="arrow" />
                    </a>
                )}
            </div>
        </div>
    );
};

export default Clients;
